import React from "react";
import { ReactComponent as DownloadIcon } from "@assets/files/icons/general/download.svg";
import { ReactComponent as ExportIcon } from "@assets/files/icons/general/export.svg";

import { ButtonProps } from "./Button";
import { ButtonPrimary } from "./ButtonEnhanced";

export const ButtonDownload: React.FC<ButtonProps> = ({ children, ...props }) => {
  return (
    <ButtonPrimary {...props}>
      <DownloadIcon />
      {children}
    </ButtonPrimary>
  );
};

export const ButtonExport: React.FC<ButtonProps> = ({ children, ...props }) => {
  return (
    <ButtonPrimary {...props}>
      <ExportIcon />
      {children}
    </ButtonPrimary>
  );
};
